import { SvgIcon, SvgIconProps } from "@mui/material";

// "End sale": a bold pound sign at standard icon height with a small red
// cross in the bottom-right corner. The pound is drawn as a single stroked
// path (not a filled glyph) so it stays one flat tone at the semi-transparent
// colours MUI uses for icon buttons.
const PoundOffIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M14.6 6.1C14 4.7 12.7 3.7 11.1 3.7 8.9 3.7 7.3 5.4 7.3 7.6v5.7c0 2.8-1 5-2.6 6.7h10.4M4.3 12.6h8.2"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.6 17.6 22.4 22.4M22.4 17.6 17.6 22.4"
      stroke="#ba2224"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
  </SvgIcon>
);

export default PoundOffIcon;
